import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '~/modules/users/users.components/users-page';

export const Route = createFileRoute('/_main-layout/users')({
  component: UsersPage,
});
